import type { Utilities } from 'core/domains';
import { Bff } from 'core/services';
import { call } from 'core/middlewares/utilities';

import type { RequestAction } from '../@types';

import { getResource } from './get-resource';
import { getRequestOptions } from './get-request-options';

/**
 * Handles BFF request calls resolving request and response presenters.
 *
 */
export function* requestHandler(action: RequestAction) {
  const { presenterRequest, presenterResponse, ...options } = getResource(action);

  const response: Bff.BffResponse = yield call(
    Bff.clientBff,
    options as unknown as Utilities.PlainObject<string>,
    {
      ...(yield getRequestOptions()),
      payload: presenterRequest,
    },
  );

  return presenterResponse ? presenterResponse(response, action.payload) : response;
}
